import React from 'react';
import { Coffee, BatteryLow, Brain, Moon } from 'lucide-react';
import { useLocale } from '../utils/locale';
export function MirrorSection() {
  const locale = useLocale();
  const isAR = locale === 'ar';
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-219">
          <div data-id="element-220">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-221">
              Sé exactamente lo que se siente.
            </h2>
            <div className="space-y-6 text-lg text-navy/80 leading-relaxed" data-id="element-222">
              <p data-id="element-223">
                {isAR ? 'Te levantás' : 'Te levantas'} con el pie izquierdo,{' '}
                {isAR ? 'te mirás' : 'te miras'} al espejo y{' '}
                <strong className="text-navy" data-id="element-224">
                  {isAR ? 'no te reconocés' : 'no te reconoces'}
                </strong>
                . {isAR ? 'Sentís esa' : 'Sientes esa'}{' '}
                <strong className="text-navy" data-id="element-225">inflamación en la cara</strong>,
                esa{' '}
                <strong className="text-navy" data-id="element-226">pesadez en los párpados</strong>.
              </p>
              <p data-id="element-227">
                {isAR ? 'Te preparás' : 'Te preparas'} un café (el tercero del
                día) solo para poder empezar a trabajar. Pero a las 11 AM ya
                estás <strong className="text-navy" data-id="element-228">buscando algo dulce</strong>
                . No es hambre, es tu{' '}
                <span className="text-accent font-semibold" data-id="element-229">
                  cerebro pidiendo clemencia
                </span>{' '}
                porque{' '}
                <strong className="text-navy" data-id="element-230">
                  {isAR ? 'se quedó sin nafta' : 'se quedó sin combustible'}
                </strong>
                .
              </p>
              <p data-id="element-231">
                {isAR ? 'Llegás a la noche' : 'Llegas a la noche'}{' '}
                <strong className="text-navy" data-id="element-232">tan agotado</strong> que ni
                siquiera {isAR ? 'tenés' : 'tienes'} ganas de estar con tu
                familia. {isAR ? 'Vivís en' : 'Vives en'}{' '}
                <strong className="text-navy" data-id="element-233">piloto automático</strong>.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-234">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-235">
              <BatteryLow className="w-8 h-8 text-accent mb-3" data-id="element-236" />
              <span className="font-medium text-navy" data-id="element-237">Energía al 10%</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-238">
              <Coffee className="w-8 h-8 text-accent mb-3" data-id="element-239" />
              <span className="font-medium text-navy" data-id="element-240">Dependencia al café</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-241">
              <Brain className="w-8 h-8 text-accent mb-3" data-id="element-242" />
              <span className="font-bold text-navy" data-id="element-243">Niebla mental</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-244">
              <Moon className="w-8 h-8 text-accent mb-3" data-id="element-245" />
              <span className="font-medium text-navy" data-id="element-246">
                Agotamiento nocturno
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}